import React, { Component } from 'react';
import { Popover, Button,Input} from 'antd';

const InputGroup = Input.Group;
import {CopyToClipboard} from 'react-copy-to-clipboard';

export default class Copyurl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
      visible: false,
      data: props.data || {}
    };
  }
  componentWillReceiveProps(nextProps){
    this.setState({data:nextProps.data,visible:false})
  }
  handleVisibleChange = (visible) => {
    this.setState({ visible });
  }
  onCopy = ()=>{
    cb.utils.alert('复制成功', 'success');
  }
  geturl(){
    let url;
    let pid = this.state.data.id;
    let pstyles = this.props.model.getParent().getParams().billNo;
		let pstyle;
		if(pstyles == 'pmc_productpromotionlist'){
				pstyle = 'PP'; 
		}else if(pstyles == 'pmc_giftpreferentiallist'){
				pstyle = 'GP'; 
		}else if(pstyles == 'pmc_wholesalelist'){
				pstyle = 'TP'; 
		}else if(pstyles == 'pmc_groupbuyinglist'){
				pstyle = 'GB'; 
		}else if(pstyles == 'pmc_assemblebuyinglist'){
				pstyle = 'AB'; 
		}
    url = '/list?promotionActivityId='+ pstyle + pid;
    return url
  }
  render() {
    let erpCode = this.geturl() 
    const content = (<div style={{padding:'0 10px'}}>
        <Input defaultValue={erpCode} value={erpCode} disabled={true} style={{ width: '215px' }} />
        <CopyToClipboard text={erpCode} onCopy={this.onCopy}>
          <a style={{paddingLeft:'10px',color:'#588ce9'}}>复制链接</a>
        </CopyToClipboard>
    </div>
    );
    return (
      <Popover content={content}  trigger="click"  mouseLeaveDelay={0.5}  placement="bottomRight" onVisibleChange={this.handleVisibleChange}>
        {this.props.children}
      </Popover>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/popover/Copyurl.jsx